export default __webpack_public_path__ + "static/rovo-menu-dont-light-d77502b656c51282e9ca7535579d45e3.png";